import { render, staticRenderFns } from "./DatatableThead.vue?vue&type=template&id=eccbc71e&scoped=true&"
import script from "./DatatableThead.vue?vue&type=script&lang=js&"
export * from "./DatatableThead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccbc71e",
  null
  
)

export default component.exports